<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader class="px-4 pt-4">
        <h2 class="text-text-neutral-primary text-base font-medium">
          {{ t('general.search') }}
        </h2>
        <template #rightAction>
          <FreeCloseButton class="gray-header-close-button" @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div class="p-4">
        <SearchForm
          source="search_page"
          @onSearchFormSubmit="
            (query, iata) => emit('onSearchFormSubmit', query, iata)
          "
        />
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { FreeBottomSheet, FreeHeader, FreeCloseButton } from 'freedom-shared';
  import { useI18n } from 'vue-i18n';

  import { SearchForm } from '@/widgets/search-form';

  const props = defineProps<{
    name: string;
  }>();

  const { t } = useI18n();

  const emit = defineEmits<{
    onSearchFormSubmit: [searchParams: string, airlineIata?: string];
  }>();
</script>
